import { Dayjs } from 'dayjs';
import { TFunction } from 'i18next';
import { AnyObject, mixed, MixedSchema } from 'yup';

export const DATE_TO_TEST = (
  t: TFunction,
  fieldName: string,
): MixedSchema<Dayjs | undefined, AnyObject, undefined, ''> =>
  mixed<Dayjs>().test({
    message: t('date.notEarlierThen', { from: 'Od', to: 'Do' }),
    name: 'dateToAfterFrom',
    test: (value, context) => {
      if (!value) {
        return true;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const dateFrom = context.parent[fieldName] as Dayjs;
      if (!dateFrom) {
        return true;
      }
      return value.isAfter(dateFrom.subtract(1, 'day'));
    },
  });
